import { render, staticRenderFns } from "./NewSii.vue?vue&type=template&id=63f226e6&scoped=true&"
import script from "./NewSii.vue?vue&type=script&lang=ts&"
export * from "./NewSii.vue?vue&type=script&lang=ts&"
import style0 from "./NewSii.vue?vue&type=style&index=0&id=63f226e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f226e6",
  null
  
)

export default component.exports